import * as React from 'react';
import { Pivot, PivotItem } from '@fluentui/react/lib/Pivot';
import * as types from '../../types';
import GenExport from '../export/GenExport';

export interface IManageProjectsReportClsProps extends types.IBaseComponentProps {
}

export interface IManageProjectsReportClsState {
}
export class ManageProjectsReportClsState implements IManageProjectsReportClsState {
}

export default class ManageProjectsReportCls extends React.Component<IManageProjectsReportClsProps, ManageProjectsReportClsState> {
    constructor(props: IManageProjectsReportClsProps, state: IManageProjectsReportClsState) {
        super(props);
        this.state = new ManageProjectsReportClsState();
    }

    public render(): React.ReactElement<IManageProjectsReportClsProps> {
        return (
            <React.Fragment>
                <Pivot>
                    <PivotItem headerText="Export to Excel" itemKey="Export to Excel">
                        {this.renderGenExport()}
                    </PivotItem>
                </Pivot>
            </React.Fragment>
        );
    }

    private renderGenExport(): React.ReactElement<types.IWebPartComponentProps> {

        const isSuperUserPermission: boolean = this.isSuperUser();
        return (
            <div>
                <div style={{ paddingTop: "10px" }}>
                    {(isSuperUserPermission === true) &&
                        <GenExport
                            {...this.props}
                            moduleName="PROJPORT"

                        />
                    }
                    {
                        (isSuperUserPermission === false) &&
                        <div style={{ fontSize: '14px', color: 'navy', fontStyle: 'italic', paddingTop: '8px', paddingLeft: '5px' }}>
                            Export to Excel function is only available to the Super User.
                        </div>
                    }

                </div>
            </div>
        );

    }

    private isSuperUser(): boolean {
        return this.props.userPermissions.UserIsSystemAdmin();
    }
}